export default __webpack_public_path__ + "static/media/loader.a4634378.svg";